import { Users, Settings, LogOut, Network, Link2 } from 'lucide-react';
import './Sidebar.css';

function Sidebar({ userEmail, onLogout, isOpen, toggleSidebar, activePage, onNavigate }) {
  const handleNavClick = (e, page) => {
    e.preventDefault();
    onNavigate(page);
  };

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <h2>Painel Rateio PRO</h2>
        <button className="close-sidebar-btn" onClick={toggleSidebar}>×</button>
      </div>
      <nav className="sidebar-nav">
        <a 
          href="#gerenciar" 
          className={`nav-item ${activePage === 'gerenciar' ? 'active' : ''}`}
          onClick={(e) => handleNavClick(e, 'gerenciar')}
        >
          <Users size={20} />
          <span>Gerenciar</span>
        </a>

        <a 
          href="#proxy" 
          className={`nav-item ${activePage === 'proxy' ? 'active' : ''}`}
          onClick={(e) => handleNavClick(e, 'proxy')}
        >
          <Network size={20} />
          <span>Proxy</span>
        </a>

        <a 
          href="#allowedUrls" 
          className={`nav-item ${activePage === 'allowedUrls' ? 'active' : ''}`}
          onClick={(e) => handleNavClick(e, 'allowedUrls')}
        >
          <Link2 size={20} />
          <span>URLs Permitidas</span>
        </a>

        <a 
          href="#config" 
          className={`nav-item ${activePage === 'config' ? 'active' : ''}`}
          onClick={(e) => handleNavClick(e, 'config')}
        >
          <Settings size={20} />
          <span>Configurações</span>
        </a>
      </nav>
      <div className="sidebar-footer">
        <span>Logado como:</span>
        <small>{userEmail}</small>
        <button onClick={onLogout} className="logout-button">
          <LogOut size={16} />
          <span>Sair</span>
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;